import { Component, ElementRef, ViewChild } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Subscription } from 'rxjs';
import { IsSidebarOpenService } from '../shared/services/is-sidebar-open.service';
import { SiteFooterComponent } from '../shared/site-footer/site-footer.component';
import { MainSidebarComponent } from './main-sidebar/main-sidebar.component';

@Component({
  selector: 'app-main',
  imports: [RouterOutlet, MainSidebarComponent, SiteFooterComponent],
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss'],
})
export class MainComponent {
  @ViewChild('container') container!: ElementRef;
  isSidebarOpenServiceSubscription!: Subscription;
  constructor(private isSidebarOpenService: IsSidebarOpenService) {
    this.isSidebarOpenServiceSubscription = this.isSidebarOpenService.isSidebarOpen.subscribe((isSidebarOpen) => {
      if (this.container) {
        if (isSidebarOpen) {
          this.container.nativeElement.classList.remove('mainContainer--left--closed');
        } else {
          this.container.nativeElement.classList.add('mainContainer--left--closed');
        }
      }
    });
  }

  async ngOnDestroy() {
    if (this.isSidebarOpenServiceSubscription) {
      this.isSidebarOpenServiceSubscription.unsubscribe();
    }
  }
}
